module.exports = __webpack_public_path__ + "static/media/profile.291decc5.svg";